const refreshTestIDs = {
  metricsTitle: 'metrics-title',
  metricsDescription: 'metrics-description',
  metricsBody: 'metrics-body',
  closeButton: 'close-button',
};

export default refreshTestIDs;
